import Vue from 'vue';
import Router from 'vue-router';
import Home from '@/views/home.vue';
import Yanfa from '@/views/yanfa.vue';
import Zhizao from '@/views/zhizao.vue';
import Success from '@/views/success.vue';
import Pages from '@/views/pages.vue';

Vue.use(Router);

export default new Router({
	mode: 'history', // 使用 history 模式
	routes: [{
		path: '/',
		name: 'Home',
		component: Home,
		meta: {
			title: '首页'
		}
	},{
		path: '/yanfa',
		name: 'Yanfa',
		component: Yanfa,
		meta: {
			title: '我需要研发'
		}
	},{
		path: '/zhizao',
		name: 'Zhizao',
		component: Zhizao,
		meta: {
			title: '我需要制造'
		}
	},{
		path: '/complete',
		name: 'Success',
		component: Success,
		meta: {
			title: '提交成功'
		}
	},{
		path: '/pages',
		name: 'Pages',
		component: Pages,
		meta: {
			title: '内容'
		}
	}]
});